<template lang="pug">
  div.pb-5
    screen-title(title="memberships.membership_packages_title")
      action-button(@click="addOrEdit" title="memberships.actions.add_package" icon="plus-circle-outline" permission="MEMBERSHIP_PACKAGES_MANAGE" scope)
    
    .box
      p.title.is-5.mb-3(v-t="'memberships.memberships_list_title'")
      b-table(:data="memberships" @click="addOrEdit" custom-row-key="_id" hoverable)
        b-table-column(field="name" :label="$t('memberships.name_heading')" v-slot="props")
          p.title.is-6
            span.icon
              i.mdi.mdi-card-account-details-outline
            span {{props.row.name}}
        b-table-column(field="price" :label="$t('memberships.value_heading')" v-slot="props" numeric)
          currency-view(:value="props.row.price")
        b-table-column(field="salePrice" :label="$t('memberships.commission_price_label')" v-slot="props" numeric)
          currency-view(:value="props.row.salePrice" v-if="props.row.salePrice !== undefined")
        b-table-column(field="availableOnline" :label="$t('memberships.available_online_heading')" v-slot="props" numeric)
          span.has-text-weight-semibold.has-text-success(v-if="props.row.availableOnline") {{$t('misc.yes')}}
          span.has-text-weight-semibold(v-else) {{$t('misc.no')}}
        b-table-column(field="validity" :label="$t('memberships.expire_heading')" v-slot="props")
          span {{props.row.validity.value}}  
          span  {{$t(`misc.${props.row.validity.unit}`)}}
        b-table-column(:label="$t('memberships.capacity_label')" v-slot="props" numeric)
          b(v-if="props.row.capacity") {{props.row.capacity}}
          b(v-else) ∞
    
    .box
      p.title.is-5.mb-3(v-t="'memberships.packages_list_title'")
      b-table(:data="packages" @click="addOrEdit" custom-row-key="_id" hoverable)
        b-table-column(field="name" :label="$t('memberships.name_heading')" v-slot="props")
          p.title.is-6
            span.icon
              i.mdi.mdi-package-variant
            span {{props.row.name}}
        b-table-column(field="price" :label="$t('memberships.value_heading')" v-slot="props" numeric)
          currency-view(:value="props.row.price")
        b-table-column(field="availableOnline" :label="$t('memberships.available_online_heading')" v-slot="props" numeric)
          span.has-text-weight-semibold.has-text-success(v-if="props.row.availableOnline") {{$t('misc.yes')}}
          span.has-text-weight-semibold(v-else) {{$t('misc.no')}}
        b-table-column(field="validity" :label="$t('memberships.expire_heading')" v-slot="props")
          span {{props.row.validity.value}}  
          span  {{$t(`misc.${props.row.validity.unit}`)}}
        b-table-column(:label="$t('memberships.services_label')" v-slot="props")
          ul
            li.px-0(v-for="{service, option, qty} in props.row.services")
              p 
                service-name-view.has-text-underline(:value="{service, option}")
                span  x  
                span.has-text-weight-bold(v-if="qty") {{qty}}
                span.has-text-weight-bold(v-else)  ∞ 
      
    
    //.columns.is-multiline
      .column.is-6
        MembershipPackageView.is-clickable(v-for="memPack in membershipPackages" @click="addOrEdit(memPack)" :key="memPack._id" :value="memPack._id" )

</template>
<script>
import {mapGetters} from 'vuex'
import CreateEditMembershipPackage from './CreateEditMembershipPackage'
import MembershipPackageView from './MembershipPackageView'
import MEMBERSHIP_TYPES from '../../../constants/membershipTypes'
export default {
  name: 'MembershipPackages',
  components: {
    MembershipPackageView
  },
  computed: {
    ...mapGetters('membershipPackages', ['membershipPackages']),
    packages() {
      return this.membershipPackages.filter(p => p.type === MEMBERSHIP_TYPES.PACKAGE)
    },
    memberships() {
      return this.membershipPackages.filter(p => p.type === MEMBERSHIP_TYPES.MEMBERSHIP)
    }
  },

  methods: {
    addOrEdit(membership) {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        fullScreen: true,
        props: {id: membership && membership._id},
        component: CreateEditMembershipPackage,
        canCancel: ['escape']
      })
    }
  }
}
</script>
